import { render, staticRenderFns } from "./ListBuyBox.vue?vue&type=template&id=7f419fec&scoped=true"
import script from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListBuyBox.vue?vue&type=style&index=0&id=7f419fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f419fec",
  null
  
)

export default component.exports